declare global {
  interface Window {
    __ECL_VAULT_CONFIG__?: {
      apiBaseUrl?: string;
      environmentBadgeLabel?: string;
    };
  }
}

function runtimeConfig() {
  if (typeof window === 'undefined') {
    return {};
  }

  return window.__ECL_VAULT_CONFIG__ ?? {};
}

function normalizeBaseUrl(value: string | undefined): string | null {
  const normalized = value?.trim();
  if (!normalized) {
    return null;
  }

  return normalized.replace(/\/+$/, '');
}

export function resolveRuntimeApiBaseUrl(fallback: string): string {
  return normalizeBaseUrl(runtimeConfig().apiBaseUrl) ?? fallback;
}

export function resolveRuntimeEnvironmentBadgeLabel(fallback: string | null): string | null {
  const normalized = runtimeConfig().environmentBadgeLabel?.trim();
  return normalized || fallback;
}

export {};
